import type { ReactNode } from 'react';
import type { PillVariant } from '../../lib/merchant/status';

// Maps each variant to its background/foreground (P1 theme tokens). `soft` is
// the neutral pink chip used for kinds/segments (pink-affair / saint-john-red).
const VARIANT: Record<PillVariant, string> = {
  active: 'bg-[var(--m-pill-active-bg)] text-[var(--m-pill-active-fg)]',
  pending: 'bg-[var(--m-pill-pending-bg)] text-[var(--m-pill-pending-fg)]',
  suspended: 'bg-[var(--m-pill-rejected-bg)] text-[var(--m-pill-rejected-fg)]',
  rejected: 'bg-[var(--m-pill-rejected-bg)] text-[var(--m-pill-rejected-fg)]',
  soft: 'bg-[var(--m-bg-alt)] text-[var(--m-brand-press)]',
};

/**
 * Mockup `.pill`: 11px bold uppercase chip, ls 0.04em, soft shadow.
 * `dot` prepends a 6px currentColor dot (the `.pill-dot::before` glyph).
 * `children` lets callers prepend an icon before the label.
 */
export function StatusPill({
  variant,
  label,
  dot = false,
  children,
}: {
  variant: PillVariant;
  label: string;
  dot?: boolean;
  children?: ReactNode;
}): JSX.Element {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-[var(--m-r-pill)] px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.04em] shadow-[var(--m-shadow-sm)] ${VARIANT[variant]}`}
    >
      {dot && <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-current" aria-hidden="true" />}
      {children}
      {label}
    </span>
  );
}
